export const defaultProductTemplate = (baseDate: Date = new Date()) => `{
  "productIdentifier": "SKU-000145",
  "commodityName": "Smartphone",
  "productDescription": "Consumer smartphone model X",
  "hsCode": "851713",
  "hsType": "ELECTRONICS",
  "hsCommodityName": "Smartphones",
  "hsCommodityDescription": "Cellular telephones",
  "contacts": [
    {
      "role": "REQUESTOR",
      "persons": [
        {
          "givenName": "Alex",
          "familyName": "Bernard",
          "email": "alex.bernard@example.com"
        }
      ]
    }
  ],
  "externalReferences": [
    {
      "externalReferenceType": "SELLER_ID",
      "reference": "PRD-${baseDate.getUTCFullYear()}-001"
    }
  ]
}`;
